import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const DiscoveryModeTracks = () => {
  const exportDraftCampaign = () =>
    AuthAxios.get(`${DataApiUrl}/admin/discovery-mode/export-draft-campaign`)
      .then(res => res?.data || {})
      .catch(err => console.error(err.message));

  return {
    exportDraftCampaign,
  };
};

export default DiscoveryModeTracks;
